'use client';
import React from 'react';
import Link from 'next/link';

const footerLinks = {
  'Healing Services': [
    { label: 'Quantum Karmic Healing', href: '/#services' },
    { label: 'Clinical Hypnotherapy', href: '/#services' },
    { label: 'Past Life Regression', href: '/services/past-life-regression' },
    { label: 'Family Constellation', href: '/#services' },
    { label: 'Akashic Records Reading', href: '/services/akashic-records' },
    { label: 'Reiki Healing', href: '/#services' },
    { label: 'Tarot Guidance', href: '/#services' },
    { label: 'Emotional Wellness', href: '/#services' },
  ],
  'Courses': [
    { label: 'Reiki (Basic to Advance)', href: '/#courses' },
    { label: 'Lama Fera', href: '/#courses' },
    { label: 'Self Hypnosis', href: '/#courses' },
    { label: 'Violet Flame Reiki', href: '/#courses' },
    { label: 'Shri Yantra Healing', href: '/#courses' },
    { label: 'Angel Healing', href: '/#courses' },
    { label: 'Humkara & Buddhikara', href: '/#courses' },
  ],
  'Explore': [
    { label: 'About Shruti', href: '/#about' },
    { label: 'Healing Process', href: '/#process' },
    { label: 'Testimonials', href: '/#testimonials' },
    { label: 'Success Stories', href: '/#success-stories' },
    { label: 'Free Resources', href: '/#free-resources' },
    { label: 'FAQ', href: '/#faq' },
    { label: 'Contact Us', href: '/#contact' },
  ],
  'Connect': [
    { label: 'WhatsApp', href: 'https://wa.me/917049753125' },
    { label: 'Email Us', href: 'mailto:shreevidhahealing@gmail.com' },
    { label: 'Instagram', href: 'https://www.instagram.com/shreevidhahealing?igsh=czdsZzljcHB0dmp3' },
    { label: 'Facebook', href: 'https://www.facebook.com/profile.php?id=61566030202223' },
    { label: 'YouTube', href: 'https://www.youtube.com/@ShreeVidhaHealingHubb' },
    { label: 'Join Community', href: 'https://chat.whatsapp.com/JBAssqjgZSQ89CRz3EMpqn' },
  ],
};

export default function Footer() {
  return (
    <footer
      className="relative pt-16 pb-8 overflow-hidden"
      style={{
        background: 'linear-gradient(180deg, #0d0818 0%, #080410 100%)',
        borderTop: '1px solid rgba(201,168,76,0.22)',
      }}
    >
      <div className="absolute inset-0 lotus-bg opacity-30 pointer-events-none" />
      <div
        className="absolute top-0 left-1/2 -translate-x-1/2 w-px h-16"
        style={{ background: 'linear-gradient(to bottom, rgba(201,168,76,0.5), transparent)' }}
      />

      <div className="max-w-7xl mx-auto px-6 relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-6 gap-8 mb-12">
          {/* Brand */}
          <div className="lg:col-span-2">
            <div className="flex items-center gap-3 mb-4">
              <div className="relative w-10 h-10">
                <div className="absolute inset-0 rounded-full border border-[#c9a84c]/40" style={{ animation: 'rotateSlow 25s linear infinite' }} />
                <div className="absolute inset-0 flex items-center justify-center">
                  <span className="text-[#c9a84c] text-lg">✦</span>
                </div>
              </div>
              <div>
                <span
                  className="font-serif text-lg font-semibold"
                  style={{
                    background: 'linear-gradient(135deg, #c9a84c 0%, #e8c96a 50%, #c9a84c 100%)',
                    WebkitBackgroundClip: 'text',
                    WebkitTextFillColor: 'transparent',
                    backgroundClip: 'text',
                  }}
                >
                  ShreeVidha Healing Hub
                </span>
                <span className="block text-[10px] text-[#9b7fe8]/60 tracking-[0.2em] uppercase -mt-0.5">
                  Heal • Balance • Transform
                </span>
              </div>
            </div>
            <p className="text-[#c4b5fd]/50 text-sm leading-relaxed mb-4 max-w-xs">
              Helping people heal emotionally, mentally, spiritually, and energetically through personalized healing sessions with Shruti Saxena.
            </p>
            <div className="flex flex-col gap-2 mb-5">
              <a href="tel:+917049753125" className="text-[#c4b5fd]/60 text-sm hover:text-[#c9a84c] transition-colors">📞 +91 70497 53125</a>
              <a href="mailto:shreevidhahealing@gmail.com" className="text-[#c4b5fd]/60 text-sm hover:text-[#c9a84c] transition-colors">✉ shreevidhahealing@gmail.com</a>
            </div>
            <a
              href="https://wa.me/917049753125?text=Hello%2C%20I%20would%20like%20to%20book%20a%20healing%20session"
              target="_blank"
              rel="noopener noreferrer"
              className="whatsapp-btn inline-flex text-xs"
            >
              <svg viewBox="0 0 24 24" fill="currentColor" className="w-4 h-4">
                <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
              </svg>
              Book via WhatsApp
            </a>
          </div>

          {/* Links */}
          {Object.entries(footerLinks)?.map(([category, links]) => (
            <div key={category}>
              <h4
                className="text-xs tracking-[0.3em] uppercase font-medium mb-4"
                style={{
                  background: 'linear-gradient(135deg, #c9a84c, #e8c96a)',
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent',
                  backgroundClip: 'text',
                }}
              >
                {category}
              </h4>
              <ul className="space-y-2">
                {links?.map((link) => (
                  <li key={link?.label}>
                    <Link
                      href={link?.href}
                      target={link?.href?.startsWith('http') ? '_blank' : undefined}
                      rel={link?.href?.startsWith('http') ? 'noopener noreferrer' : undefined}
                      className="text-[#c4b5fd]/50 text-xs hover:text-[#c9a84c] transition-colors duration-200"
                    >
                      {link?.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div
          className="w-full h-px mb-8"
          style={{ background: 'linear-gradient(to right, transparent, rgba(201,168,76,0.35), transparent)' }}
        />

        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-[#c4b5fd]/35 text-xs">
            &copy; 2025 ShreeVidha Healing Hub. All rights reserved.
          </p>
          <div className="flex items-center gap-2 text-[#c9a84c]/60 text-xs">
            <span>✦</span>
            <span className="tracking-widest">Heal • Balance • Transform</span>
            <span>✦</span>
          </div>
          <p className="text-[#c4b5fd]/35 text-xs">
            Designed with ♥ for spiritual seekers
          </p>
        </div>
      </div>
    </footer>
  );
}
